<script lang="ts" setup>
import { useCustomerStore } from '@stores/me/customer'
import { useAssessmentResultStore } from '@stores/assessment-result'

import { LoaderFullScreenDomain } from '@UI/Loaders/LoaderFullScreenDomain'

defineOptions({
  name: 'LayoutAssessmentResult',
})

const customerStore = useCustomerStore()
const assessmentResultStore = useAssessmentResultStore()
const isLoading = computed(() => !customerStore.hasData || assessmentResultStore.isLoading || !assessmentResultStore.getQuestions.length)
</script>

<template>
  <div
    v-if="!isLoading"
    :class="['assessment-result', assessmentResultStore.getVariant]"
  >
    <div
      v-if="$slots.header"
      class="assessment-result__header"
    >
      <slot name="header" />
    </div>
    <div class="assessment-result__content">
      <slot />
    </div>
    <div
      v-if="$slots.footer"
      class="assessment-result__footer"
    >
      <slot name="footer" />
    </div>
  </div>
  <LoaderFullScreenDomain v-else />
</template>

<style scoped lang="scss" src="@scss/layouts/assessment-result.scss" />
